import { createContext } from 'react';

const MboxModalContext = createContext(null);

export default MboxModalContext;
